import React, { useEffect, useRef, useState } from "react";

import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { useHistory } from "react-router";
import {
  deleteSearchParamIfExists,
  getSearchParam,
  setSearchParam,
} from "src/utils/methods";
import { useSelector } from "react-redux";
import Tab from "../../components/Tabs/Tab";
import Tabs from "../../components/Tabs/Tabs";
import { AudienceDataTab } from "../tabs/AudienceDataTab/AudienceDataTab";
import { ProjectSummaryTab } from "../tabs/ProjectSummaryTab/ProjectSummaryTab";
import { CreatorsInsightsTab } from "../tabs/CreatorsInsightsTab/CreatorsInsightsTab";
import { AudienceOverlapTab } from "../tabs/AudienceOverlapTab/AudienceOverlapTab";
import HorizontalScroller from "src/app/components/Tabs/components/HorizontalScroller";

function TabsContainer(props) {
  const { metadata } = props;

  const [activeTab, setActiveTab] = useState("project-summary");

  const { identity } = useSelector((state) => state.mainReducer);

  const history = useHistory();
  const ref = useRef();

  useEffect(() => {
    const activeTabFromParams = getSearchParam("activeTab");
    if (activeTabFromParams) {
      setActiveTab(activeTabFromParams);
    } else {
      setSearchParam({ history, key: "activeTab", value: activeTab });
    }
    deleteSearchParamIfExists({
      key: "scrollToTabs",
      history,
      callback: () => {
        ref.current.scrollIntoView({ behavior: "smooth" });
      },
    });
  }, []);

  const updateActiveTab = (newTab) => {
    setActiveTab(newTab);
    setSearchParam({ history, key: "activeTab", value: newTab });
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case "project-summary":
        return <ProjectSummaryTab metadata={metadata} />;
      case "creators-insights":
        return <CreatorsInsightsTab />;
      case "audience-data":
        return <AudienceDataTab />;
      case "audience-overlap":
        if (!identity.isAudienceOverlapEnabled) return null;
        return <AudienceOverlapTab />;
      default:
        return null;
    }
  };

  return (
    <div ref={ref} className="project-details-tabs-container">
      <Tabs>
        <Tab
          tabText={
            <IDHFormattedMessage id="ws_overview" defaultMessage="Overview" />
          }
          active={activeTab === "project-summary"}
          onClick={() => updateActiveTab("project-summary")}
          medium
        />
        <Tab
          tabText={
            <IDHFormattedMessage
              id="ws_creator_insights"
              defaultMessage="Creator insights"
            />
          }
          active={activeTab === "creators-insights"}
          onClick={() => updateActiveTab("creators-insights")}
          medium
        />
        <Tab
          tabText={
            <IDHFormattedMessage
              id="ws_audience_data"
              defaultMessage="Audience data"
            />
          }
          active={activeTab === "audience-data"}
          onClick={() => updateActiveTab("audience-data")}
          medium
        />
        {identity.isAudienceOverlapEnabled && (
          <Tab
            tabText={
              <IDHFormattedMessage
                id="ws_audience_overlap"
                defaultMessage="Audience overlap"
              />
            }
            active={activeTab === "audience-overlap"}
            onClick={() => updateActiveTab("audience-overlap")}
            medium
          />
        )}
      </Tabs>

      {renderTabContent()}
    </div>
  );
}

export { TabsContainer };
